import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
// ui

// style
import { createStyles, makeStyles } from "@material-ui/styles";
// components
import { useNavigate } from "react-router";

import TemplateSystem from "../components/TemplateSystem";
import SnaWorkingArea from "./components/SnaWorkingArea";
import SnaDataPrepare from "./components/dataCenter/SnaDataPrepare";
import useGotoLogin from "../components/hook/useGotoLogin";
// utils
import fireDb from "../../api/firebase/realtime/utils";
import { StoreContext } from "../../store/StoreProvider";
import Act from "../../store/actions";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);
//
const SnaPage = () => {
  const navigate = useNavigate();
  // style
  const classes = useStyles();
  // props

  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna, common } = state;
  const { locale, group } = user;
  const { dataset } = sna;
  const { moduleSetting } = common;

  // local state

  // hook
  const isLoggedIn = useGotoLogin();

  /**
   * Component說明:
   *
   * SnaDataPrepare: 準備相關資料
   * 1.開放資料集清單,個人資料集清單,團隊資料集清單
   * 2.事件分類資料
   *
   * SnaWorkingArea: sideTool,sidebar,sna顯示區
   */

  return (
    <TemplateSystem>
      <SnaDataPrepare />
      <SnaWorkingArea />
    </TemplateSystem>
  );
};

SnaPage.propTypes = {};

SnaPage.defaultProps = {};

export default SnaPage;
